import { httpClient } from "@/services";
import { downloadDoc } from "@/helper/getDownloadDoc";
function getSetting(settingsHeaders) {
	console.log('%c [  settingsHeaders  ] ', 'color:#bada55', typeof settingsHeaders, settingsHeaders );
	return settingsHeaders.reduce((acc, item) => {
		if (item.value) acc.push(item.value);
		return acc;
	}, []);
}

export default {
	state: {},
	mutations: {
		updateExportLink(state, payload) {
			downloadDoc(payload);
		},
	},
	actions: {
		async onExportLink({ commit, dispatch, rootState }, { values, requestKey, isSetting }) {

			if (!isSetting) {
				const { settings: { settingsHeaders } } = rootState;
				values.setting = getSetting(settingsHeaders);
			}
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(`/${ requestKey }/export`, values);

				if (data) {
					commit('updateExportLink', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {}
};
